import { Routes } from '@angular/router';
import { ContactsPageComponent } from './+contacts-page/contacts-page.component';

export const contactsRoutes: Routes = [
  {
    path: '',
    component: ContactsPageComponent
  }
];
